import * as React from 'react';

import { RegionalPromotionBanner } from 'bundles/front-page/components/banners/regional-promotion-banner/RegionalPromotionBanner';
import type { Languages } from 'bundles/unified-description-page-common/providers/LanguageInfoDialogProvider';
import getLanguagesMetadata from 'bundles/unified-description-page-common/utils/getLanguagesMetadata';

type Props = {
  languages?: Languages;
};

const AIDubbingCampaignBannerRenderer = ({ languages }: Props) => {
  if (!languages) return null;

  const { dubbedLanguages } = getLanguagesMetadata(languages);

  if (!dubbedLanguages.length) return null;

  return <RegionalPromotionBanner variant="blue" />;
};

export default AIDubbingCampaignBannerRenderer;
